import 'focus-visible';
import svg4everybody from 'svg4everybody';

export default function() {
    svg4everybody();
}
